'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var react = require('@chakra-ui/react');
var themeTools = require('@chakra-ui/theme-tools');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var $startColor = react.cssVar('skeleton-start-color');
var $endColor = react.cssVar('skeleton-end-color');
var baseStyle = react.defineStyle(function (props) {
  var _ref;
  var defaultStartColor = 'gray.100';
  var defaultEndColor = 'gray.50';
  var _props$startColor = props.startColor,
    startColor = _props$startColor === void 0 ? defaultStartColor : _props$startColor,
    _props$endColor = props.endColor,
    endColor = _props$endColor === void 0 ? defaultEndColor : _props$endColor,
    theme = props.theme;
  var start = themeTools.getColor(theme, startColor);
  var end = themeTools.getColor(theme, endColor);
  return _ref = {}, _defineProperty__default["default"](_ref, $startColor.variable, start), _defineProperty__default["default"](_ref, $endColor.variable, end), _defineProperty__default["default"](_ref, "opacity", 1), _defineProperty__default["default"](_ref, "borderRadius", '2px'), _defineProperty__default["default"](_ref, "borderColor", start), _defineProperty__default["default"](_ref, "background", end), _ref;
});
var Skeleton = react.defineStyleConfig({
  baseStyle: baseStyle
});
exports["default"] = Skeleton;